(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dg-judgeme-product-reviews"] && !Shopify.designMode) return;
  try {
    
  function dgJudgemeHydrateReviewImages() {
    document.querySelectorAll('.dg-judgeme-product-reviews .jdgm-rev__pic-img[data-src]:not([src])').forEach(function (image) {
      var link = image.closest('.jdgm-rev__pic-link');

      image.setAttribute('src', image.getAttribute('data-src'));

      if (link) {
        link.classList.remove('jdgm--loading');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dgJudgemeHydrateReviewImages);
  } else {
    dgJudgemeHydrateReviewImages();
  }

  document.addEventListener('jdgm.loaded', dgJudgemeHydrateReviewImages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
